/**********/
/* LOADER */
/**********/
var loaderProObject = function(injectTo,options){
	
	this.injectToElem=$(injectTo);
	this.loaderHtml='<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>';
	this.loaderAttr='data-loaderPro';

	this.enabledOnLoad=true;
	this.insertBefore=false;
	
	
	if(typeof options!="undefined"){
		if(typeof options.enabledOnLoad !="undefined") { this.enabledOnLoad = options.enabledOnLoad}
		if(typeof options.insertBefore !="undefined") { this.insertBefore = options.insertBefore}	
	}
		
		if(this.insertBefore){
			if($(this.injectToElem).parent().children('['+this.loaderAttr+']').length==0){
				$(this.injectToElem).before('<div '+this.loaderAttr+'>'+this.loaderHtml+'</div>');
			}
		}else{
			if($(this.injectToElem).children('['+this.loaderAttr+']').length==0){
				$(this.injectToElem).prepend('<div '+this.loaderAttr+'>'+this.loaderHtml+'</div>');
			}
		}

	if(this.insertBefore){
		this.elem=$(this.injectToElem).parent().find('['+this.loaderAttr+']');
	}else{
		this.elem=$(this.injectToElem).find('['+this.loaderAttr+']');
	}

	if(this.enabledOnLoad){
		this.start();
	}else{
		this.stop();
	}
}

loaderProObject.prototype.start = function (options){
	var self=this;

	$(self.elem).addClass('is-active');
}

loaderProObject.prototype.stop = function (options){
	var self=this;
	$(self.elem).removeClass('is-active');
	
}

loaderProObject.prototype.destroy = function (options){
	var self=this;
	$(self.elem).remove();
}

loaderProObject.prototype.outputHTML = function (options){
	var self=this;
	if(this.enabledOnLoad){
		var enabledHTML = " class='is-active'"
	}else{
		var enabledHTML = ""
	}
	return '<div '+this.loaderAttr+enabledHTML+'>'+self.loaderHtml+'</div>';
}